module.exports = __webpack_public_path__ + "img/api.7397e18b.svg";